<div class="card rounded border">
  <div *ngIf="member$ | async as member">
    <ng-container *ngIf="!allowEditing">
      <div class="form-field">
        <label class="readonly-label mb-0">{{ 'edit.account.details.firstname.label' | translate }}</label>
        <div class="d-flex align-items-center bg-muted rounded value-field">
          <span>{{ member.FirstName }}</span>
        </div>
      </div>
      <div class="form-field">
        <label class="readonly-label mb-0">{{ 'edit.account.details.lastname.label' | translate }}</label>
        <div class="d-flex align-items-center bg-muted rounded value-field">
          <span>{{ member.Surname }}</span>
        </div>
      </div>
      <div class="form-field">
        <label class="readonly-label mb-0">{{
          'edit.account.details.dob.label' | translate: { fgbdefault: 'Date of Birth' }
        }}</label>
        <div class="d-flex align-items-center bg-muted rounded value-field">
          <span>{{ member.DOB | date: 'd MMM, y' }}</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="allowEditing">
      <form [formGroup]="accountsDetailsForm">
        <div class="form-floating position-relative mb-3">
          <input
            id="firstname"
            class="form-control font-size-14"
            type="text"
            placeholder="Enter first name"
            formControlName="FirstName"
            readonly="readonly"
            disabled
          />
          <label class="editable-label fw-normal">{{ 'edit.account.details.firstname.label' | translate }}</label>
        </div>
        <div class="form-floating position-relative mb-3">
          <input
            id="lastname"
            class="form-control font-size-14"
            type="text"
            placeholder="Enter last name"
            formControlName="Surname"
            readonly="readonly"
            disabled
          />
          <label class="editable-label fw-normal">{{ 'edit.account.details.lastname.label' | translate }}</label>
        </div>
      </form>
    </ng-container>
    <fgb-edit-shipping-address (saved)="shippingSaved($event)" (editing)="allowEditing = $event"></fgb-edit-shipping-address>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
